import React from 'react'
import { CGE } from '../../../../common/components/CGE';
import { validateEmailFunc, isRutValid, validateCell, decode_utf8, getSignedIdStatus, transformId, beforeMaskedValueChangeRut} from '../../../../common/utils/utilsFunc';
import { useModal } from "@clayui/modal";
import FileUploaded from "../../../../common/components/FileUploader";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function VulnerableAgreementForm({props}) {
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [valueCheckBoxTerms, setValueCheckBoxTerms] = React.useState(false);
    const [valueCheckBoxTicketSubscription, setValueCheckBoxTicketSubscription] = React.useState(false);
    const [values, setValues] = React.useState({})
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [docRules, setDocRules] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const [optionsType, setOptionsType] = React.useState([]);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": props.state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }
    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }


    React.useEffect(() => {
        if(props.resetForm){
            setValues({
                typeVunerab: "", 
                qtdCuetas: "",
                includeDebt: "",
                nextBilling: "",
                cellphone: "",
                email: "",
                idClient: "",
                name: "",
                inputRut: "",
                lastName: "",
                middleName: "",
            })
            setValueCheckBoxTerms(false);
            props.setIdClient("");
            props.setDetailClientJson([]);
            props.setResetForm(false);
            setValueCheckBoxTicketSubscription(false);
        }
    }, [props.resetForm])

    function handleClickButtonClient() {
        if (values.idClient) {
            props.setIdClient(values.idClient)
            setInputValidate({ ...inputValidate, ...inputValidate.empty.idClient = false, ...inputValidate.msg.idClient = "" })
        } else {
            setInputValidate({ ...inputValidate, ...inputValidate.empty.idClient = true, ...inputValidate.msg.idClient = "Debe ingresar un Nro de Cliente" })
            props.setGlobalAlert(`Complete todos los campos obligatorios.`,"warning");
        }
    }

    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.idClient) {
            errors.empty.idClient = false;
        } else {
            errors.empty.idClient = true;
            errors.msg.idClient = "Debe ingresar un Nro de Cliente"
        }

        if(valueCheckBoxTerms){
            errors.empty.valueCheckBoxTerms = false;
        } else {
            errors.empty.valueCheckBoxTerms = true;
            errors.msg.valueCheckBoxTerms = "Debes aceptar los términos y condiciones."
        }

        if (values.inputRut) {
            errors.empty.inputRut = false;
            if (!isRutValid(values.inputRut)) {
                    errors.validated.inputRut = true;
                    errors.msg.inputRut = "Debes ingresar un RUT válido."
                } else{
                    errors.validated.inputRut = false;
                }
        } else {
            errors.empty.inputRut = true;
            errors.msg.inputRut = "Debes ingresar el RUT del solicitante."
        }


        if (values.name) {
            errors.empty.name = false;
        } else {
            errors.empty.name = true;
            errors.msg.name = "Debes ingresar el nombre"
        }

        if (values.email) {
            errors.empty.email = false;
            if (values.email && !validateEmailFunc(values.email)) {
                errors.validated.email = true;
                errors.msg.email = "Debes ingresar un correo electrónico válido"
            } else {
                errors.validated.email = false;
            }
        } else {
            errors.empty.email = true;
            errors.msg.email = "Debes ingresar el correo electrónico"
        }

        if (values.cellphone) {
            errors.empty.cellphone = false;
            if (validateCell(values.cellphone)) {
                errors.validated.cellphone = true;
                errors.msg.cellphone = "Debes ingresar un teléfono válido"
            } else {
                errors.validated.cellphone = false;
            }
        } else {
            errors.empty.cellphone = true;
            errors.msg.cellphone = "Debes ingresar el teléfono"
        }

        if (values.typeVunerab) {
            errors.empty.typeVunerab = false;
        } else {
            errors.empty.typeVunerab = true;
            errors.msg.typeVunerab = "Debes selecionar una opción"
        }

        if (values.qtdCuetas) {
            errors.empty.qtdCuetas = false;
        } else {
            errors.empty.qtdCuetas = true;
            errors.msg.qtdCuetas = "Debes selecionar una opción"
        }

        if (values.includeDebt) {
            errors.empty.includeDebt = false;
        } else {
            errors.empty.includeDebt = true;
            errors.msg.includeDebt = "Debes selecionar una opción"
        }

        if (values.nextBilling) {
            errors.empty.nextBilling = false;
        } else {
            errors.empty.nextBilling = true;
            errors.msg.nextBilling = "Debes selecionar una opción"
        }
        
        if (values.lastName) {
            errors.empty.lastName = false;
        } else {
            errors.empty.lastName = true;
            errors.msg.lastName = "Debes ingresar el apellido paterno"
        }

        if (values.middleName) {
            errors.empty.middleName = false;
        } else {
            errors.empty.middleName = true;
            errors.msg.middleName = "Debes ingresar el apellido materno"
        }

        setInputValidate(errors)
        return errors
    }

    function handleSubmit() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.","warning");
        }else if (transformId(props.state.idClientAux) !== transformId(values.idClient)) {
            props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.","warning");
        }else{
            let json=[
                {
                    "nroCliente": values.idClient,
                    "nombrePaciente": values.name,
                    "inputRut": values.inputRut,
                    "fono": values.cellphone,
                    "email": values.email,
                    "apelidoPaterno": values.lastName,
                    "apelidoMaterno": values.middleName,
                    "typeVunerab": values.typeVunerab, 
                    "qtdCuetas": values.qtdCuetas,
                    "includeDebt": values.includeDebt,
                    "nextBilling": values.nextBilling,
                    "signedIn": getSignedIdStatus(),
                    // eslint-disable-next-line no-undef
                    "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
                    "contentName": decode_utf8(props.msg_success_vulnereble_agreement),
                    "Sociedad": props.codigo_empresa,
                    "url": props.url_ws_empresa,
                    "valueCheckBoxTicketSubscription":valueCheckBoxTicketSubscription,
                    "detailClientJson":props.detailClientJson
                }
            ]
            let auxVerif = true;
            let auxObj = {};
            let countOptionFile = 0;
            let nameOptionFiles = "";

            docRules.forEach((obj) => {
                if(obj?.obligatoriedad === 2 && !values[obj.alias]) {
                    props.setGlobalAlert("Debe ingresar el archivo: "+obj.nombreDocumento,"warning", true, "Advertencia");
                    auxVerif = false;
                }else if(obj?.obligatoriedad === 1 && !values[obj.alias]) {
                    countOptionFile++;
                    nameOptionFiles += "<li>"+obj?.nombreDocumento+"</li>";
                } else {
                    auxObj[obj.alias] = values[obj.alias];
                }
            });

            if(countOptionFile === 2) {
                props.setGlobalAlert("<p>Deben ingresar al menos uno de los dos documentos: </p> <ul>"+nameOptionFiles+"</ul>","warning", true, "Advertencia");
                auxVerif = false;
            }

            json[0].files = auxObj;
            if(auxVerif) {
                props.setJsonForm(json);
            }
        }
    }

    React.useEffect(() => {
        const objResponse = props?.state?.responseTypeInte;
        if(objResponse) {
            if(objResponse.code === 0) {
                let optType = [{
                    label: "Selecione",
                    value: '',
                  },];
                  objResponse.tipoSolicitud.forEach((obj) => {
                    optType.push({ label: obj.nombre, value: obj.id });
                  });
                setOptionsType(optType)
            } else {
                props.setGlobalAlert(objResponse.message,"warning", true, "Advertencia");
            }
        }
        
    },[props?.state?.responseTypeInte]);

    React.useEffect(() => {
        if(values.nextBilling && Number(values.nextBilling) === 0) {
            props.setGlobalAlert(props?.state.webContentTextMsg,"warning", true, "Advertencia");
        }
    },[values.nextBilling])
    
    React.useEffect(() => {
        if(values.typeVunerab) {
            var filter = props?.state?.responseTypeInte?.tipoSolicitud.filter(function (obj) { return obj?.id.toString() === values.typeVunerab});
            if(filter && filter[0]?.documentos?.length > 0) {
                setDocRules(filter[0]?.documentos);
            }
        }else{
            setDocRules([]);
        }
    },[values.typeVunerab]);

    function setErroUploadFile(msgErroUploadFile) {
        props.setGlobalAlert(msgErroUploadFile, "warning");
    }

  return (
    <div id="vulnerableAgreementForm">
        <CGE.Panel
            title={decode_utf8(props.title_convenio_vulnerable) }
            description={decode_utf8(props.subtitle_convenio_vulnerable)}
        >
            <CGE.PanelSection
                title={decode_utf8(props.title_section_client)}
            >
                <div class="row">
                    <div className="col-md-12">
                        <CGE.DetailClient
                            props={{
                                handleChange: (e) => setValues({ ...values, idClient: e.target.value }),
                                hasError: inputValidate?.empty?.idClient,
                                msgError: inputValidate?.msg?.idClient,
                                idClient: values.idClient,
                                idFormElement: "numberClientId",
                                labelName: "N° Cliente:",
                                placeholder: "Número de Cliente",
                                mandatoryElement: true,
                                valuePub: values.idClient,
                                labelButton: "Buscar",
                                handleClick: () => { handleClickButtonClient() },
                                sizeButton: "sm",
                                typeButton: "primary",
                                propsLabelInfoContent:propsLabelInfoContent
                            }}
                            propsDetail={{
                                fullNameClient: (props.detailClientJson?.PRIMER_NOMBRE_PERSONA || props.detailClientJson?.SEGUNDO_NOMBRE_PERSONA
                                    || props.detailClientJson?.APELLIDO_PERSONA) ? values.socialReason = `${props.detailClientJson?.PRIMER_NOMBRE_PERSONA} 
                                    ${props.detailClientJson?.SEGUNDO_NOMBRE_PERSONA} ${props.detailClientJson?.APELLIDO_PERSONA}` : "",
                                comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                                calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                                nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                                dptoBlockClient: (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO) ? `${props.detailClientJson?.SUPLEMENTO} 
                                ${props.detailClientJson?.PISO}` : "",
                                ctaCtoClient: props.detailClientJson?.CTA_CTO
                            }}
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            <CGE.PanelSection
                    title={decode_utf8(props.title_section_solicitante_convenio_vulnerable)}>
                    <div className="row">
                        <div className="col-md-3">
                                <CGE.FormsField
                                    handleChange={(e) => setValues({ ...values, inputRut: e.target.value })}
                                    idFormElement="inputRut"
                                    mandatoryElement={true}
                                    labelName="RUT/N°"
                                    placeholder="Rut(Ej: 12345678-9)"
                                    hasError={inputValidate?.empty?.inputRut || inputValidate?.validated?.inputRut}
                                    msgError={inputValidate?.msg?.inputRut}
                                    value={values.inputRut}
                                    typeElement="input-mask"
                                    maxLength="12"
                                    beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                    formatChars={{
                                        9: "[0-9]",
                                        k: "[Kk0-9]",
                                    }}
                                    mask="9.999.999-kk"
                                    maskChar={null}
                                />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, name: e.target.value })}
                                idFormElement="name"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Nombre del solicitante convenio y/o deudor:"
                                placeholder="Nombres"
                                maxLength="40"
                                hasError={inputValidate?.empty?.name}
                                msgError={inputValidate?.msg?.name}
                                value={values.name}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, lastName: e.target.value })}
                                idFormElement="lastName"
                                mandatoryElement={true}
                                labelName="Apellido Paterno:"
                                placeholder="Apellido Paterno"
                                maxLength="40"
                                value={values.lastName}
                                typeFormElement="text"
                                typeElement="input"
                                hasError={inputValidate?.empty?.lastName}
                                msgError={inputValidate?.msg?.lastName}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, middleName: e.target.value })}
                                idFormElement="middleName"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Apellido Materno:"
                                placeholder="Apellido Materno"
                                maxLength="40"
                                value={values.middleName}
                                hasError={inputValidate?.empty?.middleName}
                                msgError={inputValidate?.msg?.middleName}
                            />
                        </div>

                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, cellphone: e.target.value })}
                                idFormElement="cellphone"
                                mandatoryElement={true}
                                typeFormElement="text"
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono:"
                                placeholder="Ej: 995048949"
                                hasError={inputValidate?.empty?.cellphone || inputValidate?.validated?.cellphone}
                                msgError={inputValidate?.msg?.cellphone}
                                value={values.cellphone}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, email: e.target.value })}
                                idFormElement="email"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Email:"
                                placeholder="Email"
                                hasError={inputValidate?.empty?.email || inputValidate?.validated?.email}
                                msgError={inputValidate?.msg?.email}
                                value={values.email}
                            />
                        </div>
                    </div>

                </CGE.PanelSection>
                <CGE.PanelSection
                    title={decode_utf8(props.title_section_vulnerabilidad_convenio_vulnerable)}>
                    <div className="row">
                        <div className="col-md-12">
                                <CGE.FormsField
                                    handleChange={(e) => setValues({ ...values, qtdCuetas: e.target.value })}
                                    idFormElement="qtdCuetas"
                                    mandatoryElement={true}
                                    labelName="Seleccione cantidad de cuotas mensuales a convenir (no puede exceder las 48):"
                                    typeElement="select"
                                    hasError={inputValidate?.empty?.qtdCuetas}
                                    msgError={inputValidate?.msg?.qtdCuetas}
                                    value={values.qtdCuetas}
                                    listOptions={props.optionsCuetas}
                                />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, nextBilling: e.target.value })}
                                idFormElement="nextBilling"
                                mandatoryElement={true}
                                labelName="Requiere que la primera cuota del convenio se realice a partir de su próxima facturación?:"
                                typeElement="select"
                                hasError={inputValidate?.empty?.nextBilling}
                                msgError={inputValidate?.msg?.nextBilling}
                                value={values.nextBilling}
                                listOptions={props.optionsFact}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, includeDebt: e.target.value })}
                                idFormElement="includeDebt"
                                mandatoryElement={true}
                                labelName="Incluir deuda generada al 18 de marzo 2020 considerando como ponto máximo de 10 UF:"
                                typeElement="select"
                                hasError={inputValidate?.empty?.includeDebt}
                                msgError={inputValidate?.msg?.includeDebt}
                                value={values.includeDebt}
                                listOptions={props.optionsFact}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, typeVunerab: e.target.value })}
                                idFormElement="typeVunerab"
                                mandatoryElement={true}
                                labelName="Tipo de vulnerabilidad a acreditar:"
                                typeElement="select"
                                hasError={inputValidate?.empty?.typeVunerab}
                                msgError={inputValidate?.msg?.typeVunerab}
                                value={values.typeVunerab}
                                listOptions={optionsType}
                            />
                        </div>
                        {docRules && docRules.length > 0 &&
                            <>
                                <div className="col-md-12">
                                    <CGE.Text text={decode_utf8(props.info_input_file_vulnereble_agreement) } size="4" />
                                </div>
                                {docRules?.map(obj => {
                                    return <div className="col-md-12" >
                                        <FileUploaded
                                            idInput={`inputFile${obj.alias}`}
                                            labelInput={obj.nombreDocumento}
                                            deleteFile={() => setValues({ ...values, [`${obj.alias}`]: null })}
                                            onFileSelectSuccess={(file) => setValues({ ...values, [`${obj.alias}`]: file })} properties
                                            setErroUploadFile={setErroUploadFile}
                                            dataProps={props}
                                            mandatoryElement={obj?.obligatoriedad === 2}
                                            maxFileSize={props?.tamano_maximo_de_archivo_MB}
                                            typeFile={props?.documento_extension}
                                            hasError={inputValidate?.empty?.fileCertificate || inputValidate?.validated?.fileCertificate}
                                            msgError={inputValidate?.msg?.fileCertificate}
                                            msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                            multiFiles={false}
                                        />
                                    </div>
                                })}
                            </>
                            
                        }
                    </div>

                </CGE.PanelSection>
                <CGE.PanelSection
                    title={decode_utf8(props.title_section_terminos_convenio_vulnerable)}>
                    <div className="row">
                        <div className="col-md-12">
                            <CGE.RenderContent textContent={props?.state?.webContentTerm} />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxTerms}
                                labelName="Acepto los términos y condiciones"
                                handleChange={() => setValueCheckBoxTerms((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={true}
                                typeElement="input"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxTicketSubscription}
                                labelName="Suscribo a boleta electrónica"
                                handleChange={() => setValueCheckBoxTicketSubscription((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={false}
                                typeElement="input"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FieldRecaptcha
                                onChange={onChangeReCaptcha}
                                sitekey={props.api_key_recaptcha}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <CGE.Button
                            label="Enviar"
                            onClick={() => handleSubmit()}
                        />
                    </div>
                </CGE.PanelSection>
        </CGE.Panel>
    </div>
  )
}

export default VulnerableAgreementForm